// extracted by mini-css-extract-plugin
export default {"btnMakeDonation":"DonationBtn_btnMakeDonation__ZSPdB","icon":"DonationBtn_icon__txfSA"};